import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import en from '../../../../lang/en-us';
import { AllDetails } from './AllDetails';
import { InvestorName } from './InvestorName';
import { ProfileProvider } from './ProfileProvider';
import { SelfOthers } from './SelfOthers';
import { Submit } from './Submit';
import InactiveFoliosDialog from './InactiveFoliosDialog';
import InactiveFoliosLink from './InactiveFoliosLink';
import AttemptsCounter from './AttemptsCounter';
import { RenderSection } from '../../faq';
import { FaqData } from '../../../../redux-store/types/faq';
import { getFaqs } from '../../../../redux-store/actions/faq';
import { useDispatch } from 'react-redux';

const { dashboard } = en;

export function SearchPage() {
    const history = useHistory();
    const location = useLocation<any>();
    const { reqId, attemptsLeft, pan, registerDetails } = location.state;
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [faqs, setFaqs] = useState<FaqData[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!reqId) {
            history.push('/links/mitra');
        }
    }, []);

    useEffect(() => {
        async function callApi() {
            const response: any = await dispatch(getFaqs());
            const { body = {} } = response || {};
            const faqs: FaqData[] = Object.keys(body).map((key) => {
                return {
                    sections: [...body[key]],
                    sectionLabel: key,
                    sectionId: body[key][0]?.sectionId,
                    publicRoute: body[key][0]?.publicRoute,
                };
            });
            setFaqs(faqs.filter((faq) => faq.sectionId === 'inactive_folios'));
        }
        callApi();
    }, []);
    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
    };

    const handleFaqScroll = () => {
        const faqSection = document.querySelector('.faq-curved');
        if (faqSection) {
            faqSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <ProfileProvider>
            <InactiveFoliosDialog
                isDialogOpen={isDialogOpen}
                handleCloseDialog={handleCloseDialog}
            />
            <div className="curved-bg">
                <AttemptsCounter attemptsLeft={attemptsLeft} />
                <div className="header-link">
                    <h2 className="heading">
                        <a
                            role="button"
                            tabIndex={0}
                            aria-label="Go back"
                            onClick={() => history.goBack()}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    history.goBack();
                                }
                            }}
                        >
                            <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                        </a>
                        {dashboard.inactiveFolios.profileInfo}
                    </h2>
                    <SelfOthers />
                </div>
                <InactiveFoliosLink
                    handleOpenDialog={handleOpenDialog}
                    handleFaqScroll={handleFaqScroll}
                />
                <div className="card-bg">
                    <InvestorName />
                    <hr
                        style={{
                            borderTop: '1px solid #DBD0EB',
                            width: '100%',
                            marginBottom: '10px',
                        }}
                    />
                    <AllDetails pan={pan} />
                    <Submit reqId={reqId} pan={pan} registerDetails={registerDetails} />
                    <InactiveFoliosFaqs faqs={faqs} />
                </div>
            </div>
        </ProfileProvider>
    );
}

const InactiveFoliosFaqs = ({ faqs = [] }: { faqs: FaqData[] }) => {
    return (
        <div
            className="curved-bg faq-curved"
            style={{ backgroundColor: 'white', border: 0, padding: 0, maxHeight: 'unset' }}
        >
            <div className="curved-bg-content desktop_mode" style={{ width: '100%', margin: 0 }}>
                <div className="faq-content-outer">
                    <div className="if-faq-content-right">
                        <div className="faq-content-right-content">
                            <div className="faq-list">
                                {faqs.map((faq, index) => (
                                    <RenderSection
                                        key={index}
                                        {...faq}
                                        sectionLabel="Inactive Folios FAQs"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="faq-mobile mobile_mode">
                <div className="faq-sections">
                    <div className="faq-answers">
                        <div className="faq-list">
                            {faqs.map((faq, index) => (
                                <RenderSection key={index} {...faq} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
